import { render, staticRenderFns } from "./MaterialCardSmallSbaDashboard.vue?vue&type=template&id=39f1a838&scoped=true"
import script from "./MaterialCardSmallSbaDashboard.vue?vue&type=script&lang=js"
export * from "./MaterialCardSmallSbaDashboard.vue?vue&type=script&lang=js"
import style0 from "./MaterialCardSmallSbaDashboard.vue?vue&type=style&index=0&id=39f1a838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f1a838",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VIcon,VRow})
